
import React from 'react';
import InstitutionsLogo from '../../../../images/institutionsLogo.png';
import TranslatedCopy from '../../../intl/translated-copy';
import { getCMSUrl } from '../../../constants/cms-urls';
import PropTypes from 'prop-types';

const RefundFooterBottom = ({ country, language }) => {
  const date = new Date();
  const yearNow = date.getFullYear();
  return (
    <div className='RefundFooterBottom'>
      <div className='RefundFooterBottom-listContainer'>
        <li className='RefundFooterBottom-listContainer--rightsTitle'>&copy; { yearNow } Aeroméxico. <TranslatedCopy copyID='APP_ALL_RIGHTS_RESERVED' /></li>
        <li className='RefundFooterBottom-listContainer--partitionLineFooter'>|</li>
        <a
          className='RefundFooterBottom-listContainer--legal'
          href={ getCMSUrl(country, language, 'LEGAL') }
          rel='noopener noreferrer'
          target='_blank'>
          <TranslatedCopy copyID='APP_LEGAL' />
        </a>
        <li className='RefundFooterBottom-listContainer--partitionLineFooter'>|</li>
        <a
          className='RefundFooterBottom-listContainer--privacy'
          href={ getCMSUrl(country, language, 'LEGAL') }
          rel='noopener noreferrer'
          target='_blank'>
          <TranslatedCopy copyID='APP_PRIVACY_POLICY' />
        </a>
        <li className='RefundFooterBottom-listContainer--partitionLineFooter'>|</li>
        <a
          className='RefundFooterBottom-listContainer--siteAccessible'
          href={ getCMSUrl(country, language, 'LEGAL') }
          rel='noopener noreferrer'
          target='_blank'>
          <TranslatedCopy copyID='MYB_ACCESIBLE_SITE' />
        </a>
      </div>
      <div className='RefundFooterBottom-contentContainer'>
        <TranslatedCopy
          className='RefundFooterBottom-contentContainer--certifiedTitle'
          copyID='MYB_CERTIFIED_BY'
          tagName='p'
        />
        <img className='RefundFooterBottom-contentContainer--institutionLogo' src={ InstitutionsLogo } />
      </div>
    </div>
  );
};

RefundFooterBottom.propTypes = {
  country: PropTypes.string,
  language: PropTypes.string,
};

export default RefundFooterBottom;